import { FC } from 'react'

import Breadcrumb, { BreadcrumbProps } from './breadcrumb'

interface Props {
  breadcrumbs: BreadcrumbProps[]
  className?: { container: string; each_breadcrumb: { link: string; title: string; last_title: string } }
}

const Breadcrumbs: FC<Props> = ({ breadcrumbs, className }) => {
  return (
    <nav className={className?.container}>
      {breadcrumbs.map((crumb, ci) => {
        return <Breadcrumb title={crumb.title} path={crumb.path} key={ci} className={className?.each_breadcrumb} />
      })}
    </nav>
  )
}

export default Breadcrumbs
